var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_17428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9832 5.82307C12.9832 5.73468 12.9109 5.66235 12.8225 5.66235L11.4966 5.66838L9.49972 8.04896L7.50485 5.67039L6.17695 5.66436C6.08856 5.66436 6.01624 5.73468 6.01624 5.82508C6.01624 5.86325 6.0303 5.89941 6.0544 5.92954L8.66802 9.04338L6.0544 12.1552C6.03013 12.1847 6.01666 12.2215 6.01624 12.2597C6.01624 12.3481 6.08856 12.4204 6.17695 12.4204L7.50485 12.4144L9.49972 10.0338L11.4946 12.4124L12.8205 12.4184C12.9089 12.4184 12.9812 12.3481 12.9812 12.2577C12.9812 12.2195 12.9671 12.1833 12.943 12.1532L10.3334 9.04137L12.947 5.92753C12.9711 5.89941 12.9832 5.86124 12.9832 5.82307Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.52991 0 0.5 4.02991 0.5 9C0.5 13.9701 4.52991 18 9.5 18C14.4701 18 18.5 13.9701 18.5 9C18.5 4.02991 14.4701 0 9.5 0ZM9.5 16.4732C5.37366 16.4732 2.02679 13.1263 2.02679 9C2.02679 4.87366 5.37366 1.52679 9.5 1.52679C13.6263 1.52679 16.9732 4.87366 16.9732 9C16.9732 13.1263 13.6263 16.4732 9.5 16.4732Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_17428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.0077ceb6.svg";
export { ForwardRef as ReactComponent };